/**
 * Pages the TrustPulse pop-up is hidden on.
 *
 * Each entry covers that path and every path under it, so "/checkout" also
 * hides it on "/checkout/success/". A trailing slash makes no difference. To
 * hide or show the pop-up somewhere else, add or remove a line here; nothing
 * else needs changing.
 *
 * This list is in code, not only in the TrustPulse dashboard, because
 * TrustPulse checks its page rules once, on a full page load. The site moves
 * between pages without one, so a pop-up that opened on the home page stayed
 * up after a click through to the cart. Keep the dashboard rules as well: they
 * stop it opening when someone lands on one of these pages directly.
 */
export const TRUSTPULSE_HIDDEN_PATHS = ["/cart", "/checkout"];
